import sift from "sift"; // import { generateBuilderSlug } from "../utils";

export var initTownhomes = function initTownhomes(a, b) {
  b.parseSlug;
  return {
    list: function list() {
      var b = a.current || {},
          c = (b || {}).townhomes;

      if (c) {
        var d = {
          $and: [],
          $or: []
        };
        d.$and.length || delete d.$and, d.$or.length || delete d.$or, c = c.filter(sift(d));
      }

      return c || [];
    },
    retrieve: function retrieve(b) {
      var c = a.current || {},
          d = (c || {}).townhomes,
          e = void 0 === d ? [] : d,
          f = e.find(function (a) {
        return a.slug === b;
      });
      return f && f.lots && f.lots.length && f.lots.map(function (c) {
        return c.packages = c.packages.map(function (c) {
          return c && c.id && !c.name ? b ? a.packages.retrieve({
            id: c.id
          }) : null : c;
        }), c;
      }), f;
    }
  };
};
export default initTownhomes;